<template>
  <b-row>
      <div class="animated fadeIn">
        <!--등록된 사전예약 리스트-->
        <b-card header="등록된 사전예약 리스트">
          <b-navbar>
            <b-nav pills>
              <b-nav-item v-on:click="enrolledStatusFilterHandling(item)" :data-status=item.status :active="item.active" v-for="(item, index) in preg.status" :key="index"> {{item.text}}</b-nav-item>
            </b-nav>
            <b-navbar-nav class="ml-auto">
            <b-form-group
            label="검색"
            label-for="enrolledPreg"
            label-cols="3"
            horizontal>
            <b-form-input id="enrolledPreg" type="text" autocomplete="enrolledPreg" placeholder="게임명 또는 제목으로 검색" v-model="preg.search"></b-form-input>
            </b-form-group>
            </b-navbar-nav>
          </b-navbar>
          <b-table hover striped bordered responsive="sm" :items="this.filteredPregList" :fields="preg.fields" :current-page="preg.currentPage" :per-page="preg.perPage" :show-empty=true empty-text="리스트가 없습니다." :sort-by.sync="sortBy" :sort-desc=true>
            <template slot="market" slot-scope="data">
              {{getMarketListString(data.item.marketInfoList)}}
            </template>
            <template slot="type" slot-scope="data">
              {{getTypeName(data.item.type)}}
            </template>
            <template slot="permaUri" slot-scope="data">
              <b-link :href="pregUrl + data.item.permaUri" target="_blank">{{data.item.permaUri}}</b-link>
            </template>
            <template slot="startTime" slot-scope="data">
              {{data.item.startTime ? data.item.startTime.format('YY.MM.DD HH:mm') : '미등록'}}
            </template>
            <template slot="endTime" slot-scope="data">
              {{data.item.endTime ? data.item.endTime.format('YY.MM.DD HH:mm') : '미등록'}}
            </template>
            <template slot="regTime" slot-scope="data">
              {{data.item.regTime ? data.item.regTime.format('YY.MM.DD HH:mm') : '미등록'}}
            </template>
            <template slot="management" slot-scope="data">
              <b-link :to="{name: 'pregDetail', params: {pregId: data.item.id, appMasterId: data.item.appMasterId}}" class="mr-2">[보기]</b-link>
              <b-link :to="{name: 'pregEdit', params: {pregId: data.item.id, appMasterId: data.item.appMasterId}}" class="mr-2" v-if="isInhouseLogin() || data.item.status.value === EXPECTED">[수정]</b-link>
              <b-link :to="{name: 'fixelForm', params: {pregId: data.item.id, appMasterId: data.item.appMasterId}}" v-if="isInhouseLogin()" class="mr-2">[픽셀코드]</b-link>
              <b-link :to="{name: 'pregResult', params: {pregId: data.item.id, appMasterId: data.item.appMasterId}}">[결과조회]</b-link>
              <!--<b-badge :variant="getBadge(data.item.status)">{{data.item.status}}</b-badge>-->
            </template>
          </b-table>
          <nav>
            <b-pagination :total-rows="filteredPregList.length" :per-page="preg.perPage" v-model="preg.currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
          </nav>
        </b-card>
        <!-- 전체 게임 리스트-->
        <b-card header="전체 게임 리스트">
          <b-navbar>
            <span>각 게임 사전예약 리스트를 조회하거나 등록할 수 있어요.</span>
            <b-navbar-nav class="ml-auto">
              <b-form-group
                label="검색"
                label-for="app"
                label-cols="3"
                horizontal>
                <b-form-input id="app" type="text" autocomplete="app" placeholder="게임명으로 검색" v-model="app.search"></b-form-input>
              </b-form-group>
            </b-navbar-nav>
          </b-navbar>
          <b-table hover striped bordered responsive="sm" :items="filteredAppList" :fields="app.fields" :current-page="app.currentPage" :per-page="app.perPage" :show-empty=true empty-text="리스트가 없습니다.">
            <template slot="management" slot-scope="data">
              <!--<b-badge :variant="getBadge(data.item.status)">{{data.item.status}}</b-badge>-->
              <b-link :to="{name: 'pregsByAppMasterId', params: {appMasterId: data.item.appMasterId}}" class="mr-2">[목록]</b-link>
              <b-link :to="{name: 'pregNew', params: { appMasterId: data.item.appMasterId }}" v-if="isInhouseLogin() && isSuper">[등록]</b-link>
            </template>
          </b-table>
          <nav>
            <b-pagination :total-rows="filteredAppList.length" :per-page="app.perPage" v-model="app.currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
          </nav>
        </b-card>

        <guide-info :title="guideInfoTitle" :infoList="guideInfoList"></guide-info>
      </div>
  </b-row>
</template>
<script>
import { MODULE_NAME as PREG_MODULE, FETCH_PREGS, FETCH_CODES } from '@/store/preg/actions.type'
import { MODULE_NAME as APP_MODULE, FETCH_APPS } from '@/store/app/actions.type'
import { mapGetters, mapState, mapMutations } from 'vuex'
import { PREECEEDING, PREECEEDING_TEXT, EXPECTED, EXPECTED_TEXT, FINISH, FINISH_TEXT, ALL, ALL_TEXT } from '@/constants'
import { $showModalWithErrorMsg, $getTypeName, $getMarketListString, $isInhouseLogin } from '@/common/util'
import { SHOW_MODAL } from '@/store/ui/mutations.type'
import GuideInfo from '@/components/GuideInfo.vue'
export default {
  components: {
    GuideInfo
  },
  data () {
    return {
      guideInfoTitle: '사전예약 가이드 다운로드 안내',
      guideInfoList: [
        {
          link: '//www.dropbox.com/sh/bxrlz50hc8ytetx/AADQ5d5Ak68XRatBdsXNcIJoa?dl=0',
          text: '디자인 가이드'
        },
        {
          link: '//www.dropbox.com/sh/fkfs6nbnykiglxi/AAA1JScDhGMKRxI-X-Loo5lwa?dl=0',
          text: '어드민 이용 가이드'
        },
      ],
      sortBy: 'startTime',
      preg: {
        search: '',
        currentStatus: ALL,
        status: [
          {
            text: ALL_TEXT,
            code: ALL,
            active: true
          },
          {
            text: PREECEEDING_TEXT,
            code: PREECEEDING,
            active: false
          },
          {
            text: EXPECTED_TEXT,
            code: EXPECTED,
            active: false
          },
          {
            text: FINISH_TEXT,
            code: FINISH,
            active: false
          }],
        currentPage: 1,
        perPage: 5,
        fields: [
          {key: 'appInfo.appName', label: '게임명', class: 'align-middle text-center'},
          {key: 'market', label: '마켓', class: 'align-middle text-center'},
          {key: 'name', label: '제목', class: 'align-middle text-center'},
          {key: 'permaUri', label: '주소', class: 'align-middle text-center'},
          {key: 'type', label: '종류', class: 'align-middle text-center', thStyle: {width: '125px'}},
          {key: 'startTime', label: '시작', class: 'align-middle text-center', sortable: true, thStyle: {width: '125px'}},
          {key: 'endTime', label: '종료', class: 'align-middle text-center', sortable: true, thStyle: {width: '125px'}},
          {key: 'status.text', label: '상태', class: 'align-middle text-center', thStyle: {width: '125px'}},
          {key: 'appInfo.capriAppId', label: 'Capri App Id', class: 'align-middle text-center', thStyle: {width: '100px'}},
          {key: 'management', label: '사전예약 관리', class: 'align-middle text-center'}
        ]
      },
      app: {
        search: '',
        currentPage: 1,
        perPage: 5,
        fields: [
          {key: 'appName.ko', label: '게임명', class: 'align-middle text-center'},
          {key: 'partner.partnerName', label: '개발사', class: 'align-middle text-center'},
          {key: 'pregCount', label: '사전예약 등록 수', class: 'align-middle text-center', sortable: true, thStyle: {width: '200px'}},
          {key: 'appMasterId', label: '앱 마스터 ID', class: 'align-middle text-center', thStyle: {width: '100px'}},
          {key: 'capriAppId', label: 'Capri App Id', class: 'align-middle text-center', thStyle: {width: '100px'}},
          {key: 'management', label: '사전예약 관리', class: 'align-middle text-center', thStyle: {width: '200px'}}
        ]
      },
      currentPage: 1,
      perPage: 5,
      getTypeName: $getTypeName,
      getMarketListString: $getMarketListString,
      isInhouseLogin: $isInhouseLogin.bind(this),
      pregUrl: process.env.VUE_APP_PREG_URL,
      EXPECTED: EXPECTED
    }
  },
  mounted () {
    console.log('authGroupName')
    console.log(this.auth.authGroup.authGroupName)
    this.$store.dispatch(PREG_MODULE + FETCH_CODES)
      .catch($showModalWithErrorMsg.bind(this))
    this.$store.dispatch(PREG_MODULE + FETCH_PREGS)
      .catch($showModalWithErrorMsg.bind(this))
    this.$store.dispatch(APP_MODULE + FETCH_APPS)
      .catch($showModalWithErrorMsg.bind(this))
  },
  computed: {
    isSuper() {
      return this.auth != null && this.auth.authGroup != null
          && this.auth.authGroup.authGroupName != null
          && this.auth.authGroup.authGroupName.toLowerCase() === 'super'
    },
    filteredPregList () {
      return this.pregListWithMomentAndStatus.filter(item => {
        if (item.name == null || item.appInfo == null || item.appInfo.appName == null)
          return false
        return this.filterPregByCurrentStatus(item) && (item.name.toLowerCase().includes(this.preg.search.toLowerCase()) || item.appInfo.appName.toLowerCase().includes(this.preg.search.toLowerCase()))
      })
    },
    filteredAppList () {
      return this.$store.state.app.list.filter(item => {
        for (let lang in item.appName) {
          if (item.appName[lang] != null && item.appName[lang].toLowerCase().includes(this.app.search.toLowerCase())) {
            return true
          }
        }
        return false
        // item.name.toLowerCase().includes(this.app.search.toLowerCase())
      })
    },
    ...mapGetters('preg', [
      'pregListWithMomentAndStatus'
    ]),
    ...mapState('preg', [
      'detail', 'codes'
    ]),
    ...mapState('auth', [
      'auth'
    ])
  },
  methods: {
    filterPregByCurrentStatus (item) {
      if (this.preg.currentStatus === ALL) {
        return true
      }
      return this.preg.currentStatus === item.status.value
    },
    enrolledStatusFilterHandling (clickedItem) {
      const clickedIndex = this.preg.status.indexOf(clickedItem)
      for (let item of this.preg.status) {
        item.active = false
      }
      this.preg.status[clickedIndex].active = true
      this.preg.currentStatus = this.preg.status[clickedIndex].code
    },
    ...mapMutations('ui', [SHOW_MODAL])
  }
}
</script>
